import React from 'react';
import SEO from '../components/SEO';
import JsonLd from './JsonLd';
import Breadcrumbs from './Breadcrumbs';
import { FIRMA } from '../data/firma';
import { PERSON_SCHEMA, breadcrumbSchema } from '../data/schema';
import styles from '../css/modules/ContentPage.module.css';

// Profil autorki (spec sekcja 9). To ta strona jest zrodlem wiarygodnosci
// dla wszystkich tekstow w serwisie - kazdy blok autora linkuje tutaj.
const PATH = '/o-mnie/';

const CRUMBS = [
  { name: 'Strona główna', path: '/' },
  { name: 'O mnie', path: PATH },
];

export default function OMnie() {
  return (
    <div className={styles.page}>
      <SEO
        title="Anna Serwińska - terapeuta SI Olsztyn | Sensorini"
        description="Anna Serwińska - diagnosta i terapeutka integracji sensorycznej w Olsztynie. Kwalifikacje, doświadczenie i zakres pracy z dziećmi."
        image="/image/o-mnie.webp"
        pathname={PATH}
        type="profile"
      />
      <JsonLd data={[PERSON_SCHEMA, breadcrumbSchema(CRUMBS)]} />

      <header className={styles.hero}>
        <span className={`${styles.blob} ${styles.blobA}`} aria-hidden="true" />
        <span className={`${styles.blob} ${styles.blobB}`} aria-hidden="true" />
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>Poznaj terapeutę • Olsztyn</span>
          <h1 className={styles.h1}>O mnie - Anna Serwińska</h1>
          <p className={styles.lead}>Terapeuta i diagnosta integracji sensorycznej w Olsztynie. Terapia ręki, TUS i wsparcie dla dzieci oraz rodziców.</p>
        </div>
      </header>

      <Breadcrumbs items={CRUMBS} />

      <div className={styles.wrap}>
        <div className={styles.bioHeader}>
          <img
            className={styles.bioPhoto}
            src="/image/anna-sensorini-olsztyn-terapia-dla-dziecka-Anna.webp"
            alt="Anna Serwińska - terapeuta integracji sensorycznej w Olsztynie"
            loading="lazy"
          />
          <div>
            <p className={styles.muted}>
              Nazywam się <strong>Anna Serwińska</strong>, jestem pedagogiem i nauczycielem wczesnoszkolnym
              z wieloletnim doświadczeniem, certyfikowanym terapeutą i diagnostą integracji sensorycznej.
              Pracowałam w wielu olsztyńskich szkołach i współpracuję z fundacjami. Prowadzę terapię ręki
              oraz Trening Umiejętności Społecznych (TUS), jestem specjalistą resocjalizacji.
              Współpracuję z fizjoterapeutami, neurologopedami i psychologami.
              Moim zadaniem jest wspierać dzieci oraz młodzież w ich rozwoju i codziennym funkcjonowaniu.
            </p>
          </div>
        </div>

        <section className={styles.section}>
          <h2>Kwalifikacje i doświadczenie</h2>
          <ul className={styles.list}>
            <li>certyfikowana terapeutka i diagnostka integracji sensorycznej,</li>
            <li>pedagog i nauczycielka wczesnoszkolna z wieloletnim doświadczeniem,</li>
            <li>specjalistka resocjalizacji,</li>
            <li>terapeutka ręki oraz prowadząca Trening Umiejętności Społecznych (TUS),</li>
            <li>doświadczenie w pracy w olsztyńskich szkołach oraz we współpracy z fundacjami,</li>
            <li>stała współpraca z fizjoterapeutami, neurologopedami i psychologami.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Czym się zajmuję</h2>
          <ul className={styles.list}>
            <li>
              <a href="/diagnoza-sensoryczna-olsztyn/">diagnoza integracji sensorycznej</a> - wywiad,
              badanie dziecka i pisemna opinia z zaleceniami,
            </li>
            <li>
              <a href="/terapia-integracji-sensorycznej-olsztyn/">terapia integracji sensorycznej</a>{' '}
              prowadzona według planu ustalonego po diagnozie,
            </li>
            <li>
              <a href="/terapia-reki/">terapia ręki</a> wspierająca motorykę małą i grafomotorykę,
            </li>
            <li>
              <a href="/trening-umiejetnosci-spolecznych/">trening umiejętności społecznych (TUS)</a>,
            </li>
            <li>wsparcie pedagogiczne i konsultacje dla rodziców.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <p className={styles.callout}>
            Jeżeli jesteś z Olsztyna lub okolic to zapraszam - wspólnie zadbamy o harmonijny rozwój Twojego dziecka.
          </p>
          <div className={styles.contactRow}>
            <a className={styles.contactLink} href={`tel:${FIRMA.telefonE164}`}>tel. {FIRMA.telefon}</a>
            <a className={styles.contactLink} href={`mailto:${FIRMA.email}`}>{FIRMA.email}</a>
          </div>
        </section>
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <h2>Umów diagnozę lub konsultację w Olsztynie</h2>
          <p>Wspólnie zadbamy o harmonijny rozwój Twojego dziecka.</p>
          <div className={styles.ctaBtns}>
            <a href="/diagnoza-sensoryczna-olsztyn/" className={styles.btnPrimary} data-cta="booking" data-cta-location="final">Umów diagnozę</a>
            <a href={`tel:${FIRMA.telefonE164}`} className={styles.btnGhost}>Zadzwoń: {FIRMA.telefon}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
